'use client';

import { GetWrapupType, WrapupModuleTeamsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleTeamsComponent from "./teamscomponent";

export default class WrapupModuleTeams implements IWrapupModule {
    constructor() { }

    get id(): string { return 'teams'; }
    get name(): string { return 'Teams'; }

    canRender(wrapupData: GetWrapupType): boolean {
        const teamsData = wrapupData?.data?.teams as WrapupModuleTeamsData;
        return teamsData?.teammates?.length > 0;
    }

    getComponentClass() {
        return WrapupModuleTeamsComponent;
    }
}
